import { Action } from "redux";

export const GET_PLAN_LIST_FOR_ORGANIZATION_FAIL =
  "SUBSCRIPTION:GET_PLAN_LIST_FOR_ORGANIZATION_FAIL";

export interface GetPlanListForOrganizationFailAction extends Action {
  type: typeof GET_PLAN_LIST_FOR_ORGANIZATION_FAIL;
  organizationKeyName: string;
}

export const getPlanListForOrganizationFailAction = (
  organizationKeyName: string
): GetPlanListForOrganizationFailAction => ({
  type: GET_PLAN_LIST_FOR_ORGANIZATION_FAIL,
  organizationKeyName,
});
